import { render, staticRenderFns } from "./Structure.vue?vue&type=template&id=f3377574"
import script from "./Structure.vue?vue&type=script&lang=ts"
export * from "./Structure.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports